export const bookingStepLabels = [
	'Anwendungsfall',
	'Flächenauswahl',
	'Name und Zeit',
	'Prüfung',
	'Bestätigung',
]
